import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 납기 이행 현황(수요>작업주문 2단 트리, 지연/부족 강조) — AnalysisController#getDeliveryStatus
// (백엔드는 factoryplan/analysis/delivery-status). 크로스탭이 아니라 List<DeliveryStatusDto>를
// 그대로 내려주고(DeliveryStatusService#toTreeDtos가 treeId="003"/"003-01" 형식의 경로 문자열을
// 채번), 응답이 배열 자체다(다른 Report처럼 { data: [...] } 래핑 없음) — fp-report-screen-guide.md §B.
const getDeliveryStatus = (params) => fpApiUtil.postParams(`${ANALYSIS}/delivery-status`, params);

const fpDeliveryStatusService = { getDeliveryStatus };
export default fpDeliveryStatusService;
